export const UserPermissions = {
  ORDERS: {
    VIEW: "VIEW_AEMMA_ORDERS",
    CREATE: "CREATE_AEMMA_ORDERS",
    EDIT: "EDIT_AEMMA_ORDERS",
    DELETE: "DELETE_AEMMA_ORDERS",
  },
  PAYMENTS: {
    VIEW: "VIEW_AEMMA_PAYMENTS",
    CREATE: "CREATE_AEMMA_PAYMENTS",
    EDIT: "EDIT_AEMMA_PAYMENTS",
  },
  USERS: {
    VIEW: "VIEW_AEMMA_USERS",
    CREATE: "CREATE_AEMMA_USERS",
    EDIT: "EDIT_AEMMA_USERS",
    DELETE: "DELETE_AEMMA_USERS",
  },
  LOCATIONS: {
    VIEW: "VIEW_AEMMA_LOCATIONS",
    CREATE: "CREATE_AEMMA_LOCATIONS",
    EDIT: "EDIT_AEMMA_LOCATIONS",
    DELETE: "DELETE_AEMMA_LOCATIONS",
  },
  TRANSPORTERS: {
    VIEW: "VIEW_AEMMA_TRANSPORTERS",
    CREATE: "CREATE_AEMMA_TRANSPORTERS",
    EDIT: "EDIT_AEMMA_TRANSPORTERS",
    DELETE: "DELETE_AEMMA_TRANSPORTERS",
  },
  CUSTOMER_MANAGEMENT: {
    VIEW: "VIEW_AEMMA_CUSTOMER_MANAGEMENT",
    CREATE: "CREATE_AEMMA_CUSTOMER_MANAGEMENT",
    EDIT: "EDIT_AEMMA_CUSTOMER_MANAGEMENT",
    DELETE: "DELETE_AEMMA_CUSTOMER_MANAGEMENT",
  },
  BANKS: {
    VIEW: "VIEW_AEMMA_BANKS",
    CREATE: "CREATE_AEMMA_BANKS",
    EDIT: "EDIT_AEMMA_BANKS",
    DELETE: "DELETE_AEMMA_BANKS",
  },
  SETTLEMENT_BANKS: {
    VIEW: "VIEW_AEMMA_SETTLEMENT_BANKS",
    CREATE: "CREATE_AEMMA_SETTLEMENT_BANKS",
    EDIT: "EDIT_AEMMA_SETTLEMENT_BANKS",
    DELETE: "DELETE_AEMMA_SETTLEMENT_BANKS",
  },
  PRODUCTS: {
    VIEW: "VIEW_AEMMA_PRODUCTS",
    CREATE: "CREATE_AEMMA_PRODUCTS",
    EDIT: "EDIT_AEMMA_PRODUCTS",
    DELETE: "DELETE_AEMMA_PRODUCTS",
  },
  DELIVERY_TRACKING: {
    VIEW: "VIEW_AEMMA_DELIVERY_TRACKING",
    CREATE: "CREATE_AEMMA_DELIVERY_TRACKING",
    EDIT: "EDIT_AEMMA_DELIVERY_TRACKING",
  },
  TRUCK_TRACKING: {
    VIEW: "VIEW_AEMMA_TRUCK_TRACKING",
    CREATE: "CREATE_AEMMA_TRUCK_TRACKING",
  },
  PAYMENT_TRANSCRIPTION: {
    VIEW: "VIEW_AEMMA_PAYMENT_TRANSCRIPTION",
    CREATE: "CREATE_AEMMA_PAYMENT_TRANSCRIPTION",
    EDIT: "EDIT_AEMMA_PAYMENT_TRANSCRIPTION",
  },
  TREASURER_APPROVAL: {
    VIEW: "VIEW_AEMMA_TREASURER_APPROVAL",
    CREATE: "CREATE_AEMMA_TREASURER_APPROVAL",
    EDIT: "EDIT_AEMMA_TREASURER_APPROVAL",
  },
  FINANCE_OFFICER_APPROVAL: {
    VIEW: "VIEW_AEMMA_FINANCE_OFFICER_APPROVAL",
    CREATE: "CREATE_AEMMA_FINANCE_OFFICER_APPROVAL",
    EDIT: "EDIT_AEMMA_FINANCE_OFFICER_APPROVAL",
  },
  CUSTOMER_TRANSACTIONS: {
    VIEW: "VIEW_AEMMA_CUSTOMER_TRANSACTIONS",
  },
  KARIBU_UTILITY: {
    ACCESS: "VIEW_AEMMA_UTILITY_PORTAL",
    REPROCESS: "REPROCESS_AEMMA_UTILITY_TRANSACTIONS",
    VIEW_PAYMENT: "VIEW_AEMMA_PAYMENTS",
    CREATE_PAYMENT: "CREATE_AEMMA_PAYMENTS",
    EDIT_PAYMENT: "EDIT_AEMMA_PAYMENTS",
  },
  LOGISTICS: {
    VIEW: "VIEW_AEMMA_LOGISTICS",
    EDIT: "EDIT_AEMMA_LOGISTICS",
    VIEW_PRODUCTS: "VIEW_AEMMA_PRODUCTS",
    CREATE_PRODUCTS: "CREATE_AEMMA_PRODUCTS",
    EDIT_PRODUCTS: "EDIT_AEMMA_PRODUCTS",
    DELETE_PRODUCTS: "DELETE_AEMMA_PRODUCTS",
  },
};
